import React from 'react'
import { FullE3dcLogo, FullFlowLogo } from '.'
import { isFlowTheme } from 'src/Libs/utils'

export interface FullLogoProps {
  textColor?: string
  worldColor?: string
  containerStyle?: string
  transitionStyle?: string
}

/**
 * A wrapper for the full logo. Differentiates between the app-themes
 *
 * @see https://www.figma.com/design/2XkUgderL8Y8WDXHPhUXNJ/E3DC-Component-Catalog?node-id=4343-114&t=gGYPmS7gWf6fXIIB-1
 */
const FullLogoWrapper: React.FC<FullLogoProps> = ({ textColor, worldColor, containerStyle, transitionStyle }) => {
  if (isFlowTheme) return <FullFlowLogo containerStyle={transitionStyle} />
  return <FullE3dcLogo containerStyle={containerStyle} textColor={textColor} worldColor={worldColor} />
}

export default FullLogoWrapper
